const config = {
	apiDomain: '#{API.Domain}',
	// bookingbugApi: "#{BookingBugAPI.Domain}",
	// bookingbugPwd: "#{BookingBugAPI.PWD}"
	bookingbugApi: '',
	bookingbugPwd: ''
};

module.exports = config;



// WEBPACK FOOTER //
// ./src/config/config.prod.js